export default "__VITE_ASSET__DttqYU3x__"